import { Form } from 'antd';
import CustomerPasswordInput from '../../inputs/customerPasswordInput/CustomerPasswordInput';
import useTranslation from '../../../hooks/translation/useTranslation';
import DefaultButton from '../../components/buttons/defaultButton/DefaultButton';

export default function ChangePasswordForm({ handleSubmit, form }) {
  const { trans } = useTranslation();

  return (
    <Form layout="vertical" onFinish={handleSubmit} form={form}>
      <CustomerPasswordInput
        label={trans('old_password')}
        name="old_password"
        rules={[
          {
            required: true,
            message: trans('input_necessary'),
          },
        ]}
      />

      <CustomerPasswordInput
        label={trans('new_password')}
        name="new_password"
        rules={[
          {
            required: true,
            message: trans('input_necessary'),
          },
        ]}
      />
      <CustomerPasswordInput
        label={trans('repeat_new_password')}
        name="repeat_new_password"
        rules={[
          {
            required: true,
            message: trans('input_necessary'),
          },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue('new_password') === value) {
                return Promise.resolve();
              }
              // eslint-disable-next-line prefer-promise-reject-errors
              return Promise.reject(trans('passwords_do_not_match'));
            },
          }),
        ]}
      />
      <div className="flex w-full">
        <DefaultButton type="submit" className="basis-full text-base leading-[22px]">{trans('finish')}</DefaultButton>
      </div>
    </Form>
  );
}
